module.exports = __webpack_public_path__ + "img/zhengshu2-hui.6b251a02.png";